import { IconProps } from "../../utils/global-types/global-types";

const VirtualViewingIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M6.18 13.898a.56.56 0 0 1-.644.466c-1.647-.264-4.411-.947-4.411-2.552 0-1.054 1.295-1.82 3.134-2.285a8.4 8.4 0 0 0 1.56.833c-2.262.354-3.569 1.028-3.569 1.453 0 .277.872 1.024 3.464 1.44a.56.56 0 0 1 .466.645M10.125 14.596v1.513a.084.084 0 0 1-.144.06l-2.106-2.107 2.106-2.105a.084.084 0 0 1 .144.06v1.453c3.513-.173 5.625-1.118 5.625-1.658 0-.424-1.307-1.098-3.57-1.452a8.4 8.4 0 0 0 1.561-.833c1.839.465 3.134 1.23 3.134 2.286 0 1.668-3.238 2.616-6.75 2.783M9 2.25c-4.673 0-6.75 3.938-6.75 3.938S4.327 10.125 9 10.125s6.75-3.937 6.75-3.937S13.673 2.25 9 2.25M9 9a2.813 2.813 0 1 1 0-5.626A2.813 2.813 0 0 1 9 9"
    ></path>
    <path
      fill="currentColor"
      d="M10.607 5.699c.047.155.08.317.08.489A1.687 1.687 0 1 1 9 4.5c.172 0 .334.033.489.08A.843.843 0 1 0 10.607 5.7"
    ></path>
  </svg>
);

export default VirtualViewingIcon;
